/**
 * Copyright (c) 2010-2024 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { ReportFilterService } from '@reports/services/report-filter.service';
import { ReportFilterType } from '@reports/state/report.model';

@Component({
    selector: 'dash-gis-report-button',
    templateUrl: './report-button.component.html',
    imports: [ MatButton ]
})
export class ReportButtonComponent {
    @Output() launch = new EventEmitter<{ name: string; key: any }>();

    @Input() label: string;
    @Input() reportName: string;
    @Input() reportKey: any;
    @Input() asLink: boolean;
    @Input() filterType: ReportFilterType;
    @Input() filterField: string;
    @Input() filterValue: any;
    @Input() filterMinValue: any;
    @Input() filterMaxValue: any;

    private filterValueInternal: any;

    constructor(private filterService: ReportFilterService) {}

    launchReport() {
        const reportParams = {
            name: this.reportName,
            key: this.reportKey
        };
        if (this.filterType && this.filterField) {
            this.processInputs();
            const filterOptions = this.filterService.getFilterValue(
                this.filterType,
                this.filterField,
                this.filterValueInternal
            );
            if (filterOptions) {
                reportParams['filter'] = filterOptions;
            }
        }
        this.launch.emit(reportParams);
    }

    private processInputs() {
        if (this.filterMinValue || this.filterMaxValue) {
            this.filterValueInternal = {};
            if (this.filterMinValue) {
                this.filterValueInternal['min'] = this.filterMinValue;
            }
            if (this.filterMaxValue) {
                this.filterValueInternal['max'] = this.filterMaxValue;
            }
        } else {
            this.filterValueInternal = { value: this.filterValue };
        }
    }
}
